import { render, staticRenderFns } from "./appriskarticle.vue?vue&type=template&id=829a3fd4"
import script from "./appriskarticle.vue?vue&type=script&lang=js"
export * from "./appriskarticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports